// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const loading = document.querySelector('.loading');
    const cookieLoading = sessionStorage.getItem('cookieLoading');
    
    /**
     * Show loading screen once per session
     */
    
    if (cookieLoading != 'true') {
        loading.classList.add('loading--visible');
        sessionStorage.setItem('cookieLoading', 'true');
    }

});
